import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus } from '@fortawesome/free-solid-svg-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { MultiSelect } from 'react-multi-select-component';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import { Badge, Modal } from 'react-bootstrap';
import Cargotruck from "../../../../../assets/images/cargo-truck.png";
import Trash from "../../../../../assets/images/trash.png";
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';

import Header from '../../../../../Components/Header/Header';
import { withoutRFSToken, withRFSToken } from '../../../../../Services/axios.js';
import { GETDESTINATION, AWBADD, AWBMSG, GETSHC, GETOWNERCODE, AWBGETBTN, ADDAWB } from '../../../../../Utils/conts.js';
import { jqxCookieCall } from '../../../../../Components/common/CommonFunctions.js';

const AssignAWB = ({ isModal, closeModal, reloadGrid }) => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [gridData, setGridData] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [getShc, setGetShc] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [getBTNRows, setGetBTNRows] = useState([]);
    const [getBTNCodes, setGetBTNCode] = useState([]);
    const [selectedBTN, setSelectedBTN] = useState();
    const [filterApplied, setFilterApplied] = useState([]);

    const fetchSHC = async () => {
        try {

            const res = await withRFSToken.post(GETSHC, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.code,
                        label: item.code,
                    })) : [];
                    setGetShc(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        // Call the fetchData function to fetch data from the API
        if (isMounted.current) return;
        fetchSHC();
        fetchDestination();
        fetchOwnerCode();
        setIsLoading(false);
        setGridData();
        isMounted.current = true;
    }, []);

    const [formData, setFormData] = useState({
        BTS: { date: '', bookingtruck_date_id: '' },
        AWB: [
            { id: '1', airway_bill: '', pieces: '', weight: '', volume: '', shc: '', commodity: '', flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '' }
        ]
    })

    useEffect(() => {
        const keys = ['Assign AWB'];
        let storedData = null;

        for (const key of keys) {
            storedData = localStorage.getItem(key);
            if (storedData) break;
        }
        const parsedData = storedData ? JSON.parse(storedData) : null;
        if (parsedData && parsedData.AWB) {
            const awbWithIds = parsedData.AWB.map((item, index) => ({
                ...item,
                id: index + 1, // Start IDs from 1 and increment for each item
            }));
            setFormData({ BTS: parsedData.BTS, AWB: awbWithIds });
        }

        // if (parsedData && parsedData.AWB) {
        //     setFormData({ AWB: parsedData.AWB });
        // }
    }, []);

    const fetchBTN = async (dt) => {
        try {
            const res = await withRFSToken.post(AWBGETBTN, { date: dt })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setGetBTNRows(innerData);
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.bookingtruck_date_id,
                        label: item.bookingtruck_no + " ( " + item.board_point + " - " + item.off_point + " ) " + " - " + item.booking_type,
                    })) : [];
                    setGetBTNCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleFormOnchange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            BTS: {
                ...prevFormData.BTS,
                [name]: value
            }
        }));
        if (name === 'date') {
            fetchBTN(value);
        }
    }
    const addULDStack = () => {
        const lastId = formData.AWB.length > 0 ? parseInt(formData.AWB[formData.AWB.length - 1].id) : 0;
        const newId = (lastId + 1).toString();
        setFormData(prevFormData => ({
            ...prevFormData,
            AWB: [
                ...prevFormData.AWB,
                {
                    id: newId,
                    airway_bill: '',
                    pieces: '',
                    weight: '',
                    volume: '',
                    shc: [],
                    flight_code: '',
                    flight_number: '',
                    flight_date: '',
                    origin: '',
                    destination: ''
                }
            ]
        }));
    };
    const removeULDStack = (uldInfoId) => {
        setFormData(prevFormData => {
            return {
                ...prevFormData,
                AWB: prevFormData.AWB.filter(stack => stack.id !== uldInfoId)
            };
        });
    };

    const handleChange = (value) => {
        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a hyphen after the third character
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }

        // Add a space after the eighth character
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 13);
    };

    const handleULDInputChange = (uldInfoId, fieldName, value) => {
        if (fieldName === 'airway_bill') {
            value = handleChange(value);
        }
        setFormData(prevFormData => ({
            ...prevFormData,
            AWB: prevFormData.AWB.map(stack => {
                if (stack.id === uldInfoId) {
                    const updatedStack = { ...stack, [fieldName]: value };
                    return updatedStack;
                }
                return stack;
            })
        }));
    };

    // grid start

    const [gridSelect, setGridSelect] = useState([]);
    const gridRef = useRef(null);
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef.current) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'awb_id', type: 'string' },
                    { name: 'airway_bill', type: 'string' },
                    { name: 'pieces', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'weight', type: 'string' },
                    { name: 'volume', type: 'string' },
                    { name: 'shc', type: 'string' },
                    { name: 'commodity', type: 'string' },
                    { name: 'flight_code', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'flight_date', type: 'string' },
                ],
                // localData: gridData[activeTab],
                // id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}awb/list?type=A`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 20,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


                    setTimeout(() => {
                        const rows = window.$(gridRef.current).jqxGrid('getrows');

                        console.log("rows", rows);
                        (checkUlds).forEach(uldNumber => {
                            console.log(checkUlds);
                            rows.forEach((element, index) => {
                                if (element.uld_number == uldNumber) {
                                    window.$(gridRef.current).jqxGrid('selectrow', index);
                                }
                            });
                        });
                    }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'Airway Bill', filtertype: 'textbox', datafield: 'airway_bill', width: '28%', cellclassname: '', },
                { text: 'Pcs', filtertype: 'textbox', datafield: 'pieces', width: '15%', cellclassname: '', },
                // {
                //     text: 'Status', filtertype: 'checkedlist',
                //     filteritems: [
                //         { label: 'Departed', value: 'd' },
                //         { label: 'Loading in progress', value: 'l' },
                //         { label: 'Arrived', value: 'a' },
                //         { label: 'Received from Flight', value: 'r' },
                //         { label: 'Unloading in Progress', value: 'u' },

                //     ],

                //     datafield: 'status', width: '12%', cellclassname: '',
                // },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '12%', cellclassname: '', },
                { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '20%', cellclassname: '', },
                { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '15%', cellclassname: '', },
                // { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '10%', cellclassname: '', },
                // { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '10%', cellclassname: '', },
                // { text: 'Commodity', filtertype: 'textbox', datafield: 'commodity', width: '10%', cellclassname: '', },

            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ['20', '50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                const dataToSend = {
                    uld_number: rowData.uld_number,
                    type_code: rowData.type_code,
                    serial_number: rowData.serial_number,
                    owner_code: rowData.owner_code,
                    condition_code: rowData.condition_code,
                    asset_type: rowData.asset_type == 'Y' ? false : true
                };
                // setEditData(dataToSend);
                // setShowEdit(true);
            });
            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.airway_bill;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }

                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.airway_bill === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.airway_bill;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.airway_bill !== unselectedRowId));

                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
        }
    }, [gridData]);
    // grid end

    const handleAddUld = () => {
        const lastId = formData.AWB.length > 0 ? parseInt(formData.AWB[formData.AWB.length - 1].id) : 0;
        const existingAirwayBills = formData.AWB.map(row => row.airway_bill);
        const newRows = gridSelect
            .filter(row => !existingAirwayBills.includes(row.airway_bill)) // Exclude duplicate airway_bill
            .map((row, index) => ({
                ...row, // Copy all properties from the selected grid row
                id: (lastId + index + 1).toString() // Assign a new incremental ID
            }));
        // const newRows = gridSelect.map((row, index) => ({
        //     ...row, // Copy all properties from the selected grid row
        //     id: (lastId + index + 1).toString() // Assign a new incremental ID
        // }));
        setFormData((prevFormData) => ({
            ...prevFormData, // Keep other properties unchanged
            AWB: [...prevFormData.AWB, ...newRows] // Append newRows to the existing AWB array
        }));
        // For unselect
        gridSelect.forEach(selectedItem => {
            const selectedRowBoundIndex = selectedItem.boundindex;
            if (selectedRowBoundIndex !== undefined && selectedRowBoundIndex !== null) {
                window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            } else {
                // console.warn(`Invalid boundindex for selected item in ${gridName}:`, selectedItem);
            }
        });
    };

    const [showModal, setShowModal] = useState(false);
    const [action, setAction] = useState();
    const [isExist, setIsExist] = useState();
    const handleModalClose = () => { setShowModal(false); setAction(''); };

    const handleModalOpen = (pos) => {
        setAction(pos);
        setShowModal(true);
    };
    const handleConfirmation = (confirm) => {
        if (confirm) {
            if (action === 'd') {
                updateAssign('yes');
            } else {
                setShowModal(false);
            }
        } else {
            if (action === 'd') {
                updateAssign('no');
            } else {
                setShowModal(false);
                setAction('');
            }
        }
    }

    const validateFormData = () => {
        let isValid = true;

        for (let i = 0; i < formData.length; i++) {
            const uld = formData[i];
            if (!uld.airway_bill) {
                toast.error('Please set Airway Bill');
                isValid = false;
                break;
            }
            if (!uld.pieces) {
                toast.error('Please set Pieces');
                isValid = false;
                break;
            }
            if (!uld.flight_code) {
                toast.error('Please set Flight Code');
                isValid = false;
                break;
            }
            if (!uld.flight_number) {
                toast.error('Please set Flight Number');
                isValid = false;
                break;
            }
            if (!uld.flight_date) {
                toast.error('Please set Flight Date');
                isValid = false;
                break;
            }
            if (!uld.origin) {
                toast.error('Please set Origin');
                isValid = false;
                break;
            }
            if (!uld.destination) {
                toast.error('Please set Destination');
                isValid = false;
                break;
            }
        }
        return isValid;
    };

    const updateAssign = async (conf) => {
        if (validateFormData()) {
            const updatedFormData = {
                ...formData,
                action_confirm: conf ? conf : null, // Add this field dynamically based on confirm
            };
            try {
                const res = await withRFSToken.post(ADDAWB, updatedFormData)
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        if (res.data.response_code === 200) {
                            if (isModal) {
                                closeModal();
                            } else {
                                toast.success(res.data.response_msg);
                                window.location.href = '/AWBManager'
                            }
                        } else if (res.data.response_code === 220) {
                            handleModalOpen('d');
                            setIsExist(innerData)
                        } else {
                            toast.error(res.data.response_msg);
                        }
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    }

    return (
        <div className="">{console.log('frm', selectedBTN)}
            {isModal ? '' : <Header logo_url='/AWBManager' />}
            <div className='main-panel'>
                {isModal ? '' : <Link to="/AWBManager" className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>}
                <Row className='mt-3'>
                    <Col sm={isModal ? '12' : '9'}>
                        <Row>
                            <Col sm='12'>
                                <div className='flbg'>
                                    <div className='charter_top'>
                                        <h3>Bookingtruck Information</h3>
                                    </div>
                                    <div className='charter_from'>
                                        <Row>
                                            <Col sm='3'>
                                                <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                                                    <Form.Label>Select Date</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        placeholder=""
                                                        name='date'
                                                        value={formData.BTS.date || ''}
                                                        onChange={handleFormOnchange}
                                                    />
                                                </Form.Group>
                                                <Form.Group controlId="exampleForm.ControlInput1">
                                                    <Form.Label>Bookingtruck No</Form.Label>
                                                    <Select
                                                        options={getBTNCodes}
                                                        onChange={(selected) => {
                                                            setFormData(prevFormData => ({
                                                                ...prevFormData,
                                                                BTS: {
                                                                    ...prevFormData.BTS,
                                                                    bookingtruck_date_id: selected.value // Update with the selected value
                                                                }
                                                            }));
                                                            const slct = getBTNRows.find(option => option.bookingtruck_date_id === selected.value)
                                                            setSelectedBTN(slct);
                                                        }}
                                                        placeholder="bookingtruck No"
                                                        className='autoslct'
                                                        name="bookingtruck_date_id"
                                                        value={getBTNCodes.find(option => option.value === formData.BTS.bookingtruck_date_id) || ''}
                                                    />
                                                </Form.Group>
                                                {/* {console.log('ggg', selectedBTN)} */}
                                            </Col>
                                            <Col sm='9'>
                                                {selectedBTN ?
                                                    <div className='bookinfo'>
                                                        <h3>{selectedBTN.bookingtruck_no + " - " + selectedBTN.booking_type}</h3>
                                                        <div className='d-flex justify-content-between rabord'>
                                                            <div className='firstbrd'>
                                                                <p>Boardpoint</p>
                                                                <span>{selectedBTN.board_point}</span>
                                                            </div>
                                                            <div className='middlebrd'>
                                                                <p>{selectedBTN.date}</p>
                                                                <p><img src={Cargotruck} /></p>
                                                                <p>{selectedBTN.departure_time} - {selectedBTN.arrival_time}</p>
                                                            </div>
                                                            <div className='lastbrd'>
                                                                <p>Offpoint</p>
                                                                <span>{selectedBTN.off_point}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : ''}
                                            </Col>
                                        </Row>
                                    </div>

                                </div>
                            </Col>
                            <Col sm='12'>
                                <div className='flbg mt-3 add_awb asign_height'>
                                    <div className='d-flex justify-content-between charter_top'>
                                        <h3 className='detail_head'>Add AWB</h3>
                                        <span className="selected">
                                            Selected AWB <Badge>{formData.AWB.length}</Badge>
                                        </span>
                                    </div>

                                    <div className='stck_middle mt-3'>
                                        {formData && formData.AWB.map((section, index) => {
                                            return (
                                                <div className={index > 0 ? 'hide_header d-flex mb-3 sub_add' : 'd-flex mb-3 sub_add'} key={index}>
                                                    {/* {console.log('100', section)} */}
                                                    <div className='saairbill'>
                                                        <Form.Label>Airway Bill <span>*</span></Form.Label>
                                                        <Form.Control type="text"
                                                            name='airway_bill'
                                                            value={section.airway_bill || ''}
                                                            maxLength={13}
                                                            // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                            onChange={(e) => handleULDInputChange(section.id, 'airway_bill', e.target.value)}
                                                            disabled={isModal ? 'disabled' : ''}
                                                        />
                                                    </div>
                                                    <div className='sapiec'>
                                                        <Form.Label>Pieces <span>*</span></Form.Label>
                                                        <Form.Control type="text"
                                                            name='pieces'
                                                            value={section.pieces || ''}
                                                            maxLength='6' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6); }}
                                                            onChange={(e) => handleULDInputChange(section.id, 'pieces', e.target.value)}
                                                            disabled={isModal ? 'disabled' : ''}
                                                        />
                                                    </div>
                                                    <div className='saweight'>
                                                        <Form.Label>Weight</Form.Label>
                                                        <Form.Control type="text"
                                                            name='weight'
                                                            value={section.weight || ''}
                                                            maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                            onChange={(e) => handleULDInputChange(section.id, 'weight', e.target.value)}
                                                            disabled={isModal ? 'disabled' : ''}
                                                        />
                                                    </div>
                                                    <div className='savolume'>
                                                        <Form.Label>Volume</Form.Label>
                                                        <Form.Control type="text"
                                                            name='volume'
                                                            value={section.volume || ''}
                                                            // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                            onChange={(e) => handleULDInputChange(section.id, 'volume', e.target.value)}
                                                            disabled={isModal ? 'disabled' : ''}
                                                        />
                                                    </div>
                                                    <div className='sashc'>
                                                        <Form.Label>SHC</Form.Label>
                                                        <MultiSelect
                                                            options={getShc}
                                                            // value={getShc.filter(option => section.shc.includes(option.value))}
                                                            value={getShc.filter(option => (section.shc || []).includes(option.value))}
                                                            onChange={(selectedOptions) => {
                                                                const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                                handleULDInputChange(section.id, 'shc', selectedValues);
                                                            }}
                                                            labelledBy="Select "
                                                            className='multiselect autoslct'
                                                            name="shc"
                                                            disabled={isModal ? 'disabled' : ''}
                                                        />

                                                    </div>
                                                    <div className='sacommodity'>
                                                        <Form.Label>Commodity</Form.Label>
                                                        <Form.Control type="text"
                                                            name='commodity'
                                                            value={section.commodity || ''}
                                                            // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                            onChange={(e) => handleULDInputChange(section.id, 'commodity', e.target.value)}
                                                            disabled={isModal ? 'disabled' : ''}
                                                        />
                                                    </div>
                                                    <div className='saflight'>
                                                        <Form.Label>Flight Number <span>*</span></Form.Label>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='flightdrp'>
                                                                <Select
                                                                    options={getOwnerCodes}
                                                                    onChange={(e) => handleULDInputChange(section.id, 'flight_code', e.value)}
                                                                    placeholder="Flight"
                                                                    className='autoslct'
                                                                    name="flight_code"
                                                                    value={getOwnerCodes.find(option => option.value === section.flight_code) || ''}
                                                                    isDisabled={isModal}
                                                                />
                                                            </div>
                                                            <div className='space'>-</div>
                                                            <div className='flightn'>
                                                                <Form.Control type="text"
                                                                    name='flight_number'
                                                                    value={section.flight_number || ''}
                                                                    maxLength='8'
                                                                    // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                    onChange={(e) => handleULDInputChange(section.id, 'flight_number', e.target.value)}
                                                                    disabled={isModal ? 'disabled' : ''}
                                                                />
                                                            </div>

                                                        </div>


                                                    </div>
                                                    <div className='flight_date'>
                                                        <Form.Group>
                                                            <Form.Label>Flight Date <span>*</span></Form.Label>
                                                            <Form.Control
                                                                type="datetime-local"
                                                                name='flight_date'
                                                                value={section.flight_date}
                                                                onChange={(e) => handleULDInputChange(section.id, 'flight_date', e.target.value)}
                                                                disabled={isModal ? 'disabled' : ''}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                    <div className='saorigin'>
                                                        <Form.Label>Origin <span>*</span></Form.Label>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(e) => handleULDInputChange(section.id, 'origin', e.value)}
                                                            placeholder="Origin"
                                                            className='autoslct'
                                                            name="origin"
                                                            value={getDestination.find(option => option.value === section.origin) || ''}
                                                            isDisabled={isModal}
                                                        />
                                                    </div>
                                                    <div className='sadesti'>
                                                        <Form.Label>Destination <span>*</span></Form.Label>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(e) => handleULDInputChange(section.id, 'destination', e.value)}
                                                            placeholder="Destination"
                                                            className='autoslct'
                                                            name="destination"
                                                            value={getDestination.find(option => option.value === section.destination) || ''}
                                                            isDisabled={isModal}
                                                        />
                                                    </div>
                                                    {isModal ? '' :
                                                        <div className='imag_trash'>
                                                            {/* {formData.AWB.length > 1 && ( */}
                                                            <img src={Trash} alt='' onClick={() => removeULDStack(section.id)} />
                                                            {/* )} */}
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })}
                                        {isModal ? '' :
                                            <div className='text-end'><Button variant="primary" className='stk_add' onClick={addULDStack}> <FontAwesomeIcon icon={faPlus} />Add AWB</Button></div>
                                        }
                                    </div>
                                    <div className='text-center mt-5'>
                                        {/* <Loader isLoading={isLoading} /> */}

                                        <Button variant="light" className='stk_cancel' onClick={() => handleModalOpen('c')}>CANCEL</Button>
                                        <Button variant="primary" className='stk_save posr' disabled={isLoading} onClick={() => updateAssign(null)}>
                                            {isLoading ? <>UPDATE<div className='mvt loader-container'><span className='mvt loader'></span></div></> : 'Save'}
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    {isModal ? '' :
                        <Col sm='3'>
                            <div className='mb-3 nestedtabs rounded'>
                                <div className='d-flex justify-content-between charter_top'>
                                    <h3>AWB Overview</h3>
                                    <span className="selected">
                                        Selected AWB <Badge>{gridSelect.length}</Badge>
                                    </span>
                                </div>
                                {!isLoading && <div ref={gridRef} className='ovgrid'></div>}
                                <div className='text-center mt-3'>
                                    <Button variant="primary" className='aduld' onClick={handleAddUld}>  Add to AWB  </Button>
                                </div>
                            </div>
                        </Col>
                    }
                </Row>
            </div>
            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered size='lg'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    {action === 'd' ?
                        (
                            <>
                                <h3>Assigned {isExist.length > 1 ? "Airwaybill's" : "Airwaybill"} found</h3>
                                <p>
                                    {isExist.length > 1 ? "These AWB's are " : "This AWB  is "}
                                    already assigned. Would you like to reassign the following AWB's to <br />
                                    <span> {/* isExist && Array.from(new Set(isExist.map((value) => value.bookingtruck_no))).join(', ')}{ isExist && isExist.map((value, index) => value.bookingtruck_no) */}
                                        {selectedBTN.bookingtruck_no} - {formData.BTS.date} ?</span>

                                </p>

                                <Table striped className='uldlist'>
                                    <thead>
                                        <tr>
                                            <th>Airway Bill</th>
                                            <th>Bookingtruck No</th>
                                            <th>Bookingtruck Date</th>
                                            <th>Boardpoint</th>
                                            <th>Offpoint</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isExist && isExist.map((value, index) => (
                                            <tr key={index}>
                                                <td>{value.airway_bill}</td>
                                                <td>{value.bookingtruck_no}</td>
                                                <td>{value.departure_date}</td>
                                                <td>{value.board_point}</td>
                                                <td>{value.off_point}</td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </Table>
                                {/* <ul>
                                    {isExist?.map(awb => (
                                        <li>{awb.airway_bill}</li>
                                    ))}
                                </ul> */}

                            </>
                        )
                        :
                        (
                            <>
                                <h3>All changes will be destroyed</h3>
                                <p>If you proceed with the change, all data in this section will be removed.
                                    Are you sure you want to continue?</p>
                            </>
                        )
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={() => handleConfirmation(true)}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AssignAWB;